import { ActiveDaysRequest, PowerPlanEvent, PowerPlanEventFilter } from "@/services/powerPlans/types";
import api from "@/services/api";

export function getPowerPlanEvents(request: PowerPlanEventFilter) : Promise<PowerPlanEvent[]> {
    return new Promise((resolve, reject) => {
        api.post("/powerPlanEvents/events", request).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function getActiveDays(request: ActiveDaysRequest) : Promise<any> {
    return new Promise((resolve, reject) => {
        api.post("/powerPlanEvents/activeDays", request).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function getEvent(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
        api.get(`/powerPlanEvents/${id}`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export function createEvent(eventData: PowerPlanEvent): Promise<any> {
    return new Promise((resolve, reject) => {
        api.post("/powerPlanEvents", eventData)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
                console.log("error, what happening?", error);
            });
    });
}

export function updateEvent(id: string, eventData: any): Promise<any> {
    return new Promise((resolve, reject) => {
        api.put(`/powerPlanEvents/${id}`, eventData)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export function deleteEvent(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
        api.delete(`/powerPlanEvents/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
